const normalizeTokenCount = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? Math.round(parsed) : 0;
};

export const getFlowTokenUsage = (flow) => {
  const usage = flow?.ai_token_usage || flow?.aiTokenUsage || {};
  return {
    input_tokens: normalizeTokenCount(usage.input_tokens),
    output_tokens: normalizeTokenCount(usage.output_tokens),
    total_tokens: normalizeTokenCount(usage.total_tokens),
    request_count: normalizeTokenCount(usage.request_count)
  };
};

export const formatTokenCount = (value, language) => {
  try {
    return new Intl.NumberFormat(language || undefined).format(normalizeTokenCount(value));
  } catch (_error) {
    return String(normalizeTokenCount(value));
  }
};
